import { render, staticRenderFns } from "./AdministrativeCenterHandler.vue?vue&type=template&id=7d2bd076"
import script from "./AdministrativeCenterHandler.vue?vue&type=script&lang=js"
export * from "./AdministrativeCenterHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports